import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {webSocket, WebSocketSubject} from 'rxjs/webSocket';
import { OrderEntryService } from 'src/app/services/order-entry.service';
import {NgForm, ValidatorFn} from '@angular/forms';


@Component({
    selector: 'labels-input-dialog',
    templateUrl: 'labels-input.component.html',
    styleUrls: ['labels-input.component.css']
  })
  export class LabelsInputDialog {

    samples;
    oldSamples;
    sampleCheck;

    constructor(
        public dialogRef: MatDialogRef<LabelsInputDialog>,
        private orderEntryService: OrderEntryService,
        @Inject(MAT_DIALOG_DATA) public data: any) {

            this.samples = this.data.samples;
            this.oldSamples = this.data.oldSamples;
            this.sampleCheck = this.data.sampleCheck;
            let lastLabel = "";
            let test;
            let lastId = 0;
            
            this.samples = this.samples.filter( sample => sample!=undefined)

            console.log(this.samples)


        }

    printLabel(sample){

        console.log(sample)

        
    }

    isNew(sample){
        if(this.oldSamples){
            return this.oldSamples.filter(oldSample => oldSample.labelId == sample.labelId).length == 0
        } else{
            return false;
        }
    }


    canSave(){
        let labelId;

        for (let i = 0; i < this.samples.length; ++i){
            labelId = this.samples[i].labelId? this.samples[i].labelId :"";
            if( labelId?.length < 12 || this.samples.filter(sample=>sample.labelId == labelId)?.length > 1)
            return false;
        }

        return true;
    }


    myValidator: ValidatorFn = (c) => {
        if(this.samples.filter(sample => sample.labelId == c.value && sample.labelId != undefined).length>=1 ){
            return  { ['repeated']: true }  
        } 
        if(c.value?.length < 12){
            return  { ['short']: true }  
        } 
      };

    showSample(sample){
        for (let i = 0; i < sample.tests.length; ++i){
            if(!sample.tests[i].toDelete){
                return false;
            }
        }        
        return true;
    }

    repeatedIds;

    saveSamples(form: NgForm){
        if(this.sampleCheck){
            let ids = this.samples.filter(sample=> sample.disabled != true).map(sample => sample.labelId).toString();
            this.orderEntryService.checkSamples(ids).subscribe(
                data => {
                    this.repeatedIds = data.split(',');
                    if(this.repeatedIds[0] == ""){
                        this.dialogRef.close(this.samples)
                    }else{
                        let containers = []
                        this.repeatedIds.forEach(id => {
                            containers.push(this.samples.filter(sample => sample.labelId == id)[0]?.containerId)
                        });
                        containers.forEach(container => form.controls[container].setErrors( { ['duplicated']: true }  ))

                    }
                }
            )
        }else{
            this.dialogRef.close(this.samples)
        }
    }

  }